export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12898.fe40a4ce.jpg";